const meterTypes = {
    INPUT: 'INPUT',
    OUTPUT: 'OUTPUT'
}

export {
    meterTypes
}